export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11648.0f5f1d9e.jpg";